/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesQuotePriceListsReorderDto } from '../../models/sales-quote-price-lists-reorder-dto';

export interface QuotePriceListsControllerReorder$Params {

/**
 * The tenant identifier.
 */
  tenant: string;
      body: SalesQuotePriceListsReorderDto
}

export function quotePriceListsControllerReorder(http: HttpClient, rootUrl: string, params: QuotePriceListsControllerReorder$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<void>> {
  const rb = new SalesRequestBuilder(rootUrl, quotePriceListsControllerReorder.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as SalesStrictHttpResponse<void>;
    })
  );
}

quotePriceListsControllerReorder.PATH = '/o2-sales/quote-price-lists/{tenant}/reorder';
